import { render, staticRenderFns } from "./studentSign.vue?vue&type=template&id=b63e0954&scoped=true"
import script from "./studentSign.vue?vue&type=script&lang=js"
export * from "./studentSign.vue?vue&type=script&lang=js"
import style0 from "./studentSign.vue?vue&type=style&index=0&id=b63e0954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63e0954",
  null
  
)

export default component.exports